import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function NotInPdf({ children }) {
    const { isPDF } = useBoundContext()
    return !isPDF && children
}
